import { IconButton } from '@chakra-ui/react'

IconButton.defaultProps = { size: 'unsized' }
